import React from 'react';
import { ErrorViewProps } from './ErrorView.types';
import { getAppEnv } from '../../../../../config/env';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const ErrorView = (props: ErrorViewProps) => {
  const { title, subtitle, onRetry } = props;

  const handleOnRetry = () => {
    if (onRetry) {
      onRetry();
    }
  };

  return (
    <div className="LTSPageCommon-ErrorView-wrapper">
      <img src={`${PUBLIC_URL}/static/public/error_image.webp`} alt="art with road, trees, birds and clouds" />
      <span>{title}</span>
      {subtitle && (
        <span className="LTSPageCommon-click-transition" onClick={handleOnRetry}>
          {subtitle}
        </span>
      )}
    </div>
  );
};

export default ErrorView;
